// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__174ph","footer":"Form_footer__3_ec1"};